<template>
  <div style="height: 100%">
    <grid :config="gridConfig" ref="grid" class="no-grid-border" style="padding: 15px;" @onGet="handleGet" @onCreate="handleCreate" @editor-custom-behaviour="handlerEditorCustomBehaviour"/>
    <modal-new :config="{id: gridConfig.id, api: 'RFQ2s/Get/'}" :rfqid="rfqid" />
  </div>
</template>

<script>
import gridConfig from './GridConfig.js'
import { waitValue } from '@/utils/promises'

export default {
  name: 'PoWoBasedOnCustomerPoOpenEditor',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'modal-new': () => import(/* webpackChunkName: 'PoWoBasedOnCustomerPoOpen' */ './ModalNew')
  },
  props: {
    rfqid: {
      required: true
    },
    listRFQ2: {
      type: Array,
      required: true
    }
  },
  watch: {
    rfqid: {
      immediate: true,
      handler: 'loadData'
    }
  },
  data () {
    return {
      gridConfig: gridConfig({ parseGet: this.parserGet })
    }
  },
  computed: {
    mapListRFQ2 () {
      return this.listRFQ2.reduce((acc, item) => {
        acc[item.id] = item
        return acc
      }, {})
    }
  },
  methods: {
    getGrid () {
      return waitValue(() => this.$refs.grid)
    },
    handleCreate ({ data }) {
      this.$emit('update:listRFQ2', [...this.listRFQ2, { ...data, 'custom_chosen': true }])
    },
    handleGet (data) {
      this.$emit('update:listRFQ2', this.parserGet(data))
    },
    parserGet (data) {
      return data.map((item) => {
        const isChosen = !!(this.mapListRFQ2[item.id] && this.mapListRFQ2[item.id]['custom_chosen'])
        return {
          ...item,
          'custom_chosen': isChosen
        }
      })
    },
    handlerEditorCustomBehaviour (row, editor, data, callback) {
      const newList = [...this.listRFQ2].map((item) => {
        let customChosen = !!item['custom_chosen']
        if (item.id === row.id) {
          customChosen = !customChosen
        }
        return {
          ...item,
          'custom_chosen': customChosen
        }
      })
      this.getGrid()
        .then((grid) => {
          grid.setData(newList)
        })
      this.$emit('update:listRFQ2', newList)
      callback()
    },
    loadData () {
      this.getGrid()
        .then((grid) => {
          if (this.rfqid) {
            grid.setFilters(`rfqid == "${this.rfqid}"`)
            grid.loadData()
          } else {
            grid.setFilters()
            grid.resetData()
          }
        })
    }
  }
}
</script>
